import React from "react";

import { Provider } from "react-redux";
import { Switch, Route, Redirect as _Redirect, useRouteMatch, Redirect } from "react-router-dom";
import { useGetApplicationQuery } from "RegisterBenAdmin/api";
import { createStore } from "RegisterBenAdmin/redux";

import PartnerProvider from "Common/PartnerProvider";
import { useSiteConfig } from "Common/Redux/siteConfig";
import ScrollToTop from "Common/ScrollToTop";

import LoadingPage from "./components/LoadingPage";
import DonePage from "./pages/DonePage";
import PlanUploadPage from "./pages/PlanUploadPage";
import { planUploadURL, doneURL } from "./urls";

const AppPagesDumb = () => {
  const match = useRouteMatch();
  const { data: { benAdminLead } = {}, isLoading: isLoadingBenAdminLead } = useGetApplicationQuery();
  const { isLoading: isLoadingSiteConfig, data: _siteConfig } = useSiteConfig();
  return isLoadingSiteConfig || isLoadingBenAdminLead ? (
    <LoadingPage />
  ) : (
    <ScrollToTop>
      <Switch>
        <Route exact path={`${match.url}/`} children={() => <Redirect to={planUploadURL} />} />
        <Route path={planUploadURL} children={<PlanUploadPage />} />
        <Route path={doneURL} children={<DonePage />} />
      </Switch>
    </ScrollToTop>
  );
};

const App = () => {
  const store = createStore({});

  return (
    <Provider store={store}>
      <PartnerProvider>
        <AppPagesDumb />
      </PartnerProvider>
    </Provider>
  );
};

export default App;
